import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { addModifier, type Player } from '../../player.type';
import { Songs } from '../../status-effects/song';
import { StatusEffect } from '../../status-effects.type';
import { DieFace } from '../../face.type';
import { SoundType } from '../../sound';
import type { Technique } from '../../techniques.type';

/** Takes Rubato's place: the same two notes, spent luring rather than muting. */
export const sonnetOfSeduction: Technique = {
  ingredients: [DieFace.Note, DieFace.Note],
  title: Songs.Seduction,
  text: `Perform song (${Songs.Seduction}).`,
  // debuff: the AI picks by need, and a song alone matches none of them.
  tags: ['song', 'debuff'],
  audio: SoundType.AttackMusic,
  activate: (target: Player, source: Player) => {
    addModifier(source, StatusEffect.Song, 1, { role: 'performer', song: Songs.Seduction });
    addModifier(target, StatusEffect.Song, 1, { role: 'listener', song: Songs.Seduction });
  },
};

export class AlluringTrait extends Trait {
  static baseType = TraitType.Alluring;
  static baseTitle = 'Alluring';
  static baseText = `Plays ${Songs.Seduction} in place of Rubato. Its listener is left Dopey, and Stunned on every third stack.`;
  static baseIcon = 'trait';

  type = AlluringTrait.baseType;
  title = AlluringTrait.baseTitle;
  text = AlluringTrait.baseText;
  icon = AlluringTrait.baseIcon;

  getTechniques(techniques: Technique[]): Technique[] {
    // Rubato is only in the list when the dice can make it, so it may not be there.
    const index = techniques.findIndex((technique) => technique.title === 'Rubato');
    if (index !== -1) {
      techniques.splice(index, 1);
    }
    return [sonnetOfSeduction];
  }
}

TraitRegistry.register(AlluringTrait.baseType, AlluringTrait);
